import React from "react";
import {
  Box,
  Typography,
  Link,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const footerLinks = [
  { label: "Homepage", path: "/" },
  { label: "E Broucher", path: "/ebroucher" },
  { label: "About us", path: "/about-us" },
  { label: "Membership Registration", path: "/membership" },
];

const footerLinks1 = [
  { label: "Kalpavruksha Green", path: "" },
  { label: "Vaibhava Greens", path: "" },
  { label: "Contact Us", path: "/contact-us" },
];

const footerLinks2 = [
  { label: "Shipping & Delivery Policy", path: "/shipping-policy" },
  { label: "Return & Refund Policy", path: "/refund-policy" },
  { label: "Privacy Policy", path: "/privacy-policy" },
  { label: "Terms & Conditions", path: "/terms-and-conditions" },
];
const Footer = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box sx={{ backgroundColor: "#104349", color: "#fff" }}>
      <Box
        sx={{ maxWidth: 1400, mx: "auto", px: { xs: 2, md: "none" }, py: 5 }}
      >
        {/* Title */}

        {/* Main Content */}
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          sx={{ mt: 2 }}
        >
          <Grid item xs={12} md={4.5}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                mb: 1,
                width: isMobile ? "350px" :"400px",
              }}
            >
              NAVA KARNATAKA NIRMANA & OTHERS HOUSING WELFARE TRUST
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: 1.7,
                width: isMobile ? "380px" : "450px",
              }}
            >
              Provides an opportunity of owning a dream piece of land in
              Bengaluru’s fastest growing area. It’s the kind of life you can
              indeed build your future on. Value is our core philosophy in
              achieving the goal and providing value for money. With a sizable
              township to be built in the rapidly developing Bangalore region.
            </Typography>
          </Grid>

          <Grid item xs={12} md={2.5}>
            <Typography
              variant="h6"
              sx={{
                color: "#008037",
                mb: 2,
                fontWeight: "bold",
                letterSpacing: 1,
              }}
            >
              OUR ADDRESS
            </Typography>

            {footerLinks1.map((item, index) => (
              <Typography
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  fontSize: 16,
                  mb: 1,
                  cursor: "pointer",
                  color: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": { color: "#008037", textDecoration: "underline" },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>

          <Grid item xs={12} md={2.5}>
            <Typography
              variant="h6"
              sx={{
                color: "#008037",
                mb: 2,
                fontWeight: "bold",
                letterSpacing: 1,
              }}
            >
              POLICIES
            </Typography>

            {footerLinks2.map((item, index) => (
              <Typography
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  fontSize: 16,
                  mb: 1,
                  cursor: "pointer",
                  color: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": { color: "#008037", textDecoration: "underline" },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>

          <Grid item xs={12} md={2.5}>
            <Typography
              variant="h6"
              sx={{
                color: "#008037",
                mb: 2,
                fontWeight: "bold",
                letterSpacing: 1,
              }}
            >
              QUICK LINKS
            </Typography>

            {footerLinks.map((item, index) => (
              <Typography
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  fontSize: 16,
                  mb: 1,
                  cursor: "pointer",
                  color: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": { color: "#008037", textDecoration: "underline" },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255,255,255,.1)",
            mt: 5,
            py: 2,
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontSize: "16px", color: "#fff" }}>
            © {new Date().getFullYear()} Nava Karnataka Nirmana & Others Housing
            Welfare Trust | All Rights Reserved
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
